import React, { useState } from 'react';
import { Modal, ModalBody, ModalHeader, Button, FormGroup, Label, Input, Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import { inviteOrganization as inviteOrganizationAction } from '../../ReduxToolkit/Reducers/userManagement';
import { updateBrandRequest as updateBrandRequestAction } from '../../ReduxToolkit/Reducers/brandRequests';
import { useSelector } from 'react-redux';

const SendInvitationModal = ({ isOpen, toggle, brandRequest, inviteOrganization, updateBrandRequest, onInvitationSent }) => {
  const user = useSelector((state) => state.auth?.user || {});
  const [formData, setFormData] = useState({
    profileType: 'Brand',
    email: '',
    trialDays: '14',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSend = async () => {
    try {
      setIsLoading(true);

      const username = formData.email.split('@')[0];

      const invitePayload = {
        website: brandRequest?.website || brandRequest?.data?.brand_info?.website || '',
        name: brandRequest?.brand_name || brandRequest?.data?.brand_info?.brand_name || '',
        email: formData.email,
        username: username,
        type: 'brand',
        role: 'user',
        phone: '',
        org_source: 'admin',
        trial_period: parseInt(formData.trialDays),
        markets_of_interest: brandRequest?.data?.brand_info?.markets_of_interest?.length
          ? brandRequest.data.brand_info.markets_of_interest.map((m) => (typeof m === 'string' ? m : m.label))
          : ['Open']
      };

      const inviteResult = await inviteOrganization(invitePayload);

      if (inviteResult?.statusCode === 200) {
        const updatedFormData = {
          ...brandRequest?.data,
          invite_sent: true,
          invited_email: formData.email,
          invited_at: new Date().toISOString(),
        };

        if (brandRequest?.id) {
          await updateBrandRequest(brandRequest.id, updatedFormData, true, user?.name);
        }

        setFormData({
          profileType: 'Brand',
          email: '',
          trialDays: '14',
        });
        toggle();

        if (onInvitationSent) {
          onInvitationSent();
        }
      }
    } catch (error) {
      console.error('Error sending invitation:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      profileType: 'Brand',
      email: '',
      trialDays: '14',
    });
    toggle();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="lg"
      style={{ maxWidth: '600px' }}
    >
      <ModalHeader
        toggle={toggle}
        style={{
          borderBottom: '1px solid #e5e5e5',
          padding: '20px 24px',
        }}
      >
        <span style={{ fontSize: '20px', fontWeight: '600', color: '#222' }}>
          Send Invitation
        </span>
      </ModalHeader>

      <ModalBody style={{ padding: '32px 24px' }}>
        {/* <FormGroup style={{ marginBottom: '24px' }}>
          <Label
            for="profileType"
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '8px',
            }}
          >
            Profile Type<span style={{ color: '#dc3545' }}>*</span>
          </Label>
          <Input
            type="select"
            id="profileType"
            name="profileType"
            value={formData.profileType}
            onChange={handleInputChange}
            style={{
              padding: '12px 16px',
              fontSize: '14px',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              height: 'auto',
            }}
          >
            <option value="Brand">Brand</option>
            <option value="Retailer">Retailer</option>
          </Input>
        </FormGroup> */}

        <FormGroup style={{ marginBottom: '24px' }}>
          <Label
            for="email"
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '8px',
            }}
          >
            Email<span style={{ color: '#dc3545' }}>*</span>
          </Label>
          <Input
            type="email"
            id="email"
            name="email"
            placeholder="exmaple@gmail.com"
            value={formData.email}
            onChange={handleInputChange}
            style={{
              padding: '12px 16px',
              fontSize: '14px',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
            }}
          />
        </FormGroup>

        <FormGroup style={{ marginBottom: '32px' }}>
          <Label
            for="trialDays"
            style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#333',
              marginBottom: '8px',
            }}
          >
            Select Trial<span style={{ color: '#dc3545' }}>*</span>
          </Label>
          <Input
            type="select"
            id="trialDays"
            name="trialDays"
            value={formData.trialDays}
            onChange={handleInputChange}
            style={{
              padding: '12px 16px',
              fontSize: '14px',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              height: 'auto',
            }}
          >
            <option value="14">14 Days</option>
            <option value="30">30 Days</option>
          </Input>
        </FormGroup>
        <p style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '24px' }}>The Invite will be send as brand account</p>

        <div style={{ display: 'flex', gap: '16px' }}>
          <Button
            color="light"
            onClick={handleCancel}
            style={{
              flex: 1,
              padding: '12px 24px',
              fontSize: '15px',
              fontWeight: '500',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              background: '#fff',
              color: '#333',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSend}
            color="primary"
            style={{
              flex: 1,
              padding: '12px 24px',
              fontSize: '15px',
              fontWeight: '500',
              borderRadius: '8px',
              border: 'none',
              background: '#000',
              color: '#fff',
            }}
            disabled={!formData.email || isLoading}
          >
            {isLoading ? <Spinner size="sm" color="light" /> : 'Send'}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  inviteOrganization: inviteOrganizationAction,
  updateBrandRequest: updateBrandRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SendInvitationModal);
